/**
 * Tunables for the hero carousel. Kept in one place so the numbers can be tried out without
 * hunting through the component.
 */

/**
 * How much of the hero has to stay on screen for its trailer to keep playing, as a share of the
 * hero's own height (0-1).
 *
 * Scrolling down to the content below pauses the preview once visibility drops under this, and
 * scrolling back up resumes it from where it stopped. Raise it to pause sooner (more of the hero
 * must stay in view), lower it to let the trailer run further down the page.
 *
 * Note this is measured against the hero, not the viewport: on a viewport shorter than the hero
 * itself the ratio can never reach 1, so values close to 1 would keep the trailer paused.
 */
export const HERO_TRAILER_VISIBILITY_THRESHOLD = 0.5;
